import React from "react";

import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
import {
  GetMessage
} from '../../variables/message'

export default class AlertAndpadModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            title: 'ANDPAD削除確認ダイアログ',
            error_message:'',
            estimate: this.props.estimate,
            error_modal:false,
            cancel:true,
            titleBtn: "",
        };
        this.toggleErrorModal = this.toggleErrorModal.bind(this)
        this.closeErrorModal = this.closeErrorModal.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    toggleErrorModal({estimate=[]}){
      this.setState({
        estimate,
        error_modal: !this.state.error_modal
      });
    }

    closeErrorModal(){
      this.setState({
        error_modal: false
      });
      if(this.props.returnCallback){
        this.props.returnCallback();
      }
    }

    componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
    }
    handleKeyDown(e) {
      const escKey = e.keyCode === 27;
      if (escKey) {
        this.closeErrorModal();
      }
    }


    render() {
      const {
        cancel,
        closeBtn
      } = this.state

      return (
        <>
        <div id="requestErrorModal"></div>
        <Modal isOpen={this.state.error_modal} toggle={this.toggleErrorModal} backdrop="static">
        <div className="modal-header">
          {closeBtn?<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeErrorModal}>
            <i className="tim-icons icon-simple-remove"></i>
          </button>:""}
        </div>
        <ModalBody style={{textAlign: "center", fontSize: "18px" , color: "red"}}>
          ANDPADにファイルが連携されています<br />
          工事詳細画面_確定見積送付ツリーダイアログから<br />
          {this.props.is_change == true ? "契約期間変更後のファイルを再アップロードしてください" :  "ファイルを削除してください"}<br />
          {this.state.estimate && this.state.estimate.map((item, index) => {
            return (
              <div style={{marginTop: "10px", fontSize: "20px"}} key={index}>見積ID:&nbsp;{item}</div>
            )
          })}
        </ModalBody>
        <ModalFooter style={{justifyContent: "center"}}>
          <Button color="secondary" onClick={this.closeErrorModal}>
            閉じる
          </Button>
        </ModalFooter>
      </Modal>
      </>
      );
    }
}

